import { useEffect, useState } from 'react';
import { Paper, Button, Table, TableBody, TableCell, TableHead, TableRow, Checkbox, TableSortLabel, Grid } from '@mui/material';
import DeletePopUp from '../../../../shared_elements/components/DeletePopUp';
import { LeasesMenuList, LeasesNav } from '../../../elements';
import { ObligationsList } from '../components';
import { useParams } from 'react-router-dom';
import { globalDeleteService, globalGetService } from '../../../../utils/globalApiServices';
import { deleteEOLObligationApi, getEOLObligationApi } from '../apiServices';
import { checkApiStatus } from '../../../../utils';
import { PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import { ButtonLoader, ShowAttachments } from '../../../../shared_elements/components';
import EolObligationsCRU from '../components/EOLObligationsCRU';
import NoRecordFound from '../../../../shared_elements/NoRecordFound';
import { enqueueSnackbar } from 'notistack';
import { PermissionWrapper } from '../../../../wrappers';
import { RoleBaseAccess } from "../../../../hoc";
import LeasesBasicDetails from '../../../elements/LeasesBasicDetails';
import { trackActivity } from '../../../../utils/mixpanel';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import RevisionHistory from '../../../../shared_elements/components/RevisionHistory';
import { useDispatch, useSelector } from 'react-redux';
import fileUpload, { getApiResponse } from '../../../../utils/fileUpload';
import FileUploadLayout from '../../../../shared_elements/components/FileUploadLayout';
import { getStorage } from '../../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../../shared_elements/components/ModuleWiseRevisionHistory';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 238px)';

const ObligationsHd = ({ createSortHandler, sortInfo, toggleBulkOps, item, bulk }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `EOL Obligation`, page_type: page_type, })
    }
    const tableSorting = (key, name) => {
        return (
            <TableSortLabel
                disabled={key === "lessee" || key === "lessor" ? true : false}
                hideSortIcon={key === "lessee" || key === "lessor" ? true : false}
                sx={{ whiteSpace: "nowrap" }}
                active={sortInfo.sort_by === key ? true : false}
                direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
                onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
            >
                {name}
            </TableSortLabel>
        )

    }

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header">
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "eol_obligation", operationType: ['D'] }}>
                        <Checkbox color="primary" size="small" onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', item, item)} checked={item?.length === bulk?.ids?.length && item?.length > 0} />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell>{tableSorting("reserve_account__name", "Event")}</TableCell>
                <TableCell>{tableSorting("excess_refund", "Excess Refund")}</TableCell>
                <TableCell>{tableSorting("compensation_type", "Compensation Type")}</TableCell>
                <TableCell>{tableSorting("compensation_base", "Compensation Base")}</TableCell>
                <TableCell>{tableSorting("compensation_time", "Compensation Time")}</TableCell>
                <TableCell>{tableSorting("remarks", "Remarks")}</TableCell>
            </TableRow>
        </TableHead>
    );
};


const EOLObligation = () => {
    const { leaseSlug } = useParams();
    const dispatch = useDispatch()
    const {fileUploadDetails} = useSelector((state) => state.leases);
    const params = { leaseSlug };
    const [isLoading, setLoading] = useState(false)
    // const [exportLoader, setExportLoader] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [eolObligationInfo, setEolObligationInfo] = useState({ list: [], pagination: {} });
    const [addEditEolObligation, setAddEditEolObligation] = useState({ modal: false, data: null, mode: '' });
    const [deleteEolObligation, setDeleteEolObligation] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [attachments, setAttachments] = useState({ modal: false, data: null, mode:'' })
    const[isExport,seIsExport]=useState(false)
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const[uploadFileProgressData,setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug,setSlug]=useState({})


    useEffect(() => {
        const uploadedFileData = getApiResponse("eol_obligation", slug);
        getEolObligationList('skeletonLoader', { per_page: 50 });
        trackActivity('Page Viewed',{ page_title: 'EOL Obligations'})
       setUploadFileProgressData({uploadedFileData});
    }, []);

    const getEolObligationList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getEOLObligationApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setEolObligationInfo(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })
     dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"eol_obligation"}))
    };

    const deleteEolObligationFn = () => {
        setLoading(true);
        const idsToDelete = deleteEolObligation?.modal && deleteEolObligation?.data?.id ? [deleteEolObligation?.data?.id] : (bulk?.ids || []).map(item => item?.id);
        globalDeleteService(deleteEOLObligationApi(params), { ids: idsToDelete })
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete EOL Obligation`, success_msg: response?.data?.message, item_ids: deleteEolObligation?.data || bulk?.ids, response: response?.data })
                    setDeleteEolObligation({ modal: false, data: null });
                    getEolObligationList('fetch', {  page: eolObligationInfo?.pagination?.current_page || 1,per_page: eolObligationInfo?.pagination?.per_page || 50,  });
                    setBulk({ modal: false, ids: [], title: '', type: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                    trackActivity('Item Deleted', { page_title: `Delete EOL Obligation`, error_msg: response?.data?.message, item_ids: deleteEolObligation?.data || bulk?.ids, response: response?.data })
                }
            })
    }

    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments.data.attachments.filter(item => item.slug !== deltedslug)
            }
        });
        if (addEditEolObligation?.modal) {
            setAddEditEolObligation({
                ...addEditEolObligation,
                data: {
                    ...addEditEolObligation.data,
                    attachments: addEditEolObligation.data.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getEolObligationList('', { per_page: eolObligationInfo?.pagination?.perPage || 50 });
    }

    const toggleBulkOps = (flag, type, item) => {
        if (type === 'bulk') {
            setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
        } else {
            setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk.ids.filter(optionItem => optionItem.id !== item.id) })
        }
    }

    const createSortHandler = (key) => {
        let sortQuery = { sort_by: key };
        if (sortInfo.sort_by === key) {
            sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort: 'asc' }
        }
        setSortInfo(sortQuery)
        getEolObligationList('', { ...sortQuery, page: 1, per_page: eolObligationInfo?.pagination?.per_page || 50, });
    }

    const handleExport = () => {
        let query = { export: true }
        if (sortInfo?.sort && sortInfo?.sort_by) {
            query = {
                ...query,
                sort: sortInfo?.sort,
                sort_by: sortInfo?.sort_by
            }
        }
        seIsExport(true);
        globalGetService(getEOLObligationApi(params, query)).then((response) => {
            if (checkApiStatus(response)) {
                enqueueSnackbar(
                    response?.data.message,
                    { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                );
                seIsExport(false);
            }
        })
    }
    
    const handleUpload = async (slug, mode) => {
        setSlug({slug:slug})
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "eol_obligation",
            slug: slug,
            query: { record_action_type: mode },
            onStart: () => setLoading(true),
            onComplete: () => setLoading(false),
            onProgress: ({ progressRefs, attachments ,response}) => {
                setUploadFileProgressData({ progressRefs, attachments ,response});
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }});
                getEolObligationList("", { per_page: eolObligationInfo?.pagination?.per_page || 50 });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }});
            }
        });
       setSlug({})
    }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `EOL Obligation`, page_type: page_type, })
    }

    return (
        <>
        <LeasesBasicDetails/>
         <Paper className='lease-details-section section-overflow lease-module-paper' elevation={0}>
            <LeasesNav type="terms"/>
                <div className='lease-details-content contnet-overflow'>
                    <Paper square className="responsive-paper">
                        <Grid container className="responsive-grid" alignItems='flex-end'>
                            <Grid item size={{ md: 12, xs: 12 }} className="menu-container">
                                <LeasesMenuList btnText="EOL Obligation" type="terms"/>
                            </Grid>
                             <Grid item size={{ md: 6, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                        </Grid>
                        <Grid item size={{ md: 6, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding:'0px', float:'right'}}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: {slug:params?.leaseSlug,type:"global"} })}/> </li>
                                    {
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "eol_obligation", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="contained" size="small" color='error'>{`Delete (${bulk?.ids?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {eolObligationInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} variant="outlined" size='small' onClick={() => { handleExport(); handleItemClicked('Export Button') }}> Export </Button> </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "eol_obligation", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'> <Button startIcon={<AddOutlinedIcon />} variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { setAddEditEolObligation({ modal: true, data: { event: null, excess_refund: "", compensation_time: "", compensation_type: "", compensation_base: "", remarks: "" }, mode: 'add' }); handleItemClicked('Add Item Button') }}> Add EOL Obligation </Button> </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                <Paper className='lease-detail-table table-container lease-module-paper' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: eolObligationInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                    <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={4} rowCount={11} /> : (
                            <Table className="mui-table-format" stickyHeader>
                                <ObligationsHd sortInfo={sortInfo} createSortHandler={createSortHandler} bulk={bulk} item={eolObligationInfo?.list} toggleBulkOps={toggleBulkOps} />
                                <TableBody>
                                    {eolObligationInfo?.list?.length > 0 && eolObligationInfo?.list?.map((item, index) =>{
                                           const uploadedFileData = getApiResponse("amendment", item?.slug);

                                        return (
                                            <ObligationsList
                                                slug={slug?.slug}
                                                uploadedFileData={uploadedFileData }
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
                                                onEditFn={() => setAddEditEolObligation({ modal: true, data: item, mode: 'edit' })}
                                                onView={() => setAddEditEolObligation({ modal: true, data: item, mode: 'view' })}
                                                onDeleteEolFn={() => {
                                                    setDeleteEolObligation({ modal: true, data: item });
                                                    setBulk({ modal: false, ids: [item], title: '', type: '' });
                                                }}
                                                toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                onOpenAttachments={() => setAttachments({ modal: true, data: item })} />
                                        )
                                    }
                                    ) }
                                </TableBody>
                            </Table>
                        )}
                    </div>
                    <Paper square>
                        {!skeletonLoader && !eolObligationInfo?.list?.length && <NoRecordFound />}
                        <Pagination
                            pagination={eolObligationInfo?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getEolObligationList('pageLoader', { page: pageNum, per_page: eolObligationInfo?.pagination?.per_page, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}), }); }} onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getEolObligationList('pageLoader', { page: 1, per_page: perPage, ...(sortInfo?.sort_by ? { sort_by: sortInfo.sort_by, sort: sortInfo.sort } : {}), }); }}
                        />
                    </Paper>
                </Paper>
            </div>
        </Paper>
            {
                addEditEolObligation.modal && <EolObligationsCRU
                    fileUpload={handleUpload}
                    params={params}
                    modeType={addEditEolObligation.mode}
                    addEditObligation={addEditEolObligation}
                    onOpenAttachments={() => setAttachments({ modal: true, data: addEditEolObligation?.data, mode:'view' })}
                    getResponseBack={() => {getEolObligationList('fetch', { per_page: eolObligationInfo?.pagination?.per_page || 20 }); setBulk({modal: false, ids: [], type: '', title: ''})}}
                    onToggleModal={() => setAddEditEolObligation({ modal: false, mode: '', data: null })}
                />
            }

            {deleteEolObligation.modal &&
                <DeletePopUp
                    modal={deleteEolObligation.modal}
                    title='Delete EOL Obligation'
                    content={`Are you sure, you want to Delete?`}
                    onToggleModal={() => {
                        setDeleteEolObligation({ modal: false, data: null });
                        setBulk({ modal: false, ids: [], title: '', type: '' });
                    }}
                    onDeleteRecords={() => deleteEolObligationFn()}
                />}
            {attachments.modal ?
                <ShowAttachments
                    moduleName="EOL Obligation"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null, mode:'' })}
                    onViewDisabled={addEditEolObligation?.mode === 'view' || attachments?.mode==='view'}
                    permissionKey='eol_obligation'
                /> : null
            }
            {bulk.modal ?
                <DeletePopUp
                    modal={bulk.modal}
                    title={`Delete ${bulk?.ids?.length === (eolObligationInfo?.list?.length || 0) ? 'All EOL Obligations' : 'Selected EOL Obligations'}`}
                    onDeleteRecords={() => deleteEolObligationFn()}
                    content={`Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?`}
                    onToggleModal={() => setBulk({ modal: false, ids: [], title: '', type: '' })}
                /> : null
            }
            
           {
             revisionHistory.modal &&  
             <RevisionHistory 
             moduleName={"eol_obligation"}
             revisionHistory={revisionHistory}
             onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
            />
           }
            <FileUploadLayout
               uploadFileStatus={uploadFileStatus}
               open={uploadFileStatus?.modal}
               setUploadFileStatus={setUploadFileStatus}
               uploadFileProgressData={uploadFileProgressData}
               progressRefs={uploadFileProgressData?.progressRefs}
               attachments={uploadFileProgressData?.attachments}
               onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(EOLObligation, { application: 'lease_revamp', feature: 'eol_obligation', operationType: ['R'], leaseNav: true });
